import TreatmentActivitiesSection from './worksheets-section'
export default TreatmentActivitiesSection
